import React, { useEffect, useState } from 'react';
import { USER_URL } from '../../constant/api';

function AgentCode() {
  const [agentCode, setAgentCode] = useState("");
  const [inputCode, setInputCode] = useState("");
  const [loading, setLoading] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchAgentCode = async () => {
      try {
        const response = await USER_URL.get('/accounts/agent/');
        setAgentCode(response.data.data || "");
      } catch (err) {
        console.error("Error fetching agent code:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchAgentCode();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setIsSubmitting(true);
    try {
      const response = await USER_URL.post('/accounts/agent/', { agent_code: inputCode });
      setAgentCode(inputCode);
      console.log(response);  
      setInputCode("");
    } catch (err) {
      console.error("Error submitting agent code:", err);
      const errorMsg =
        err.response && err.response.data && err.response.data.detail
          ? err.response.data.detail
          : "Error occurred.";
      setError(errorMsg);
    } finally {
      setIsSubmitting(false);
    }
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-full">
        Loading...
      </div>
    );
  }

  return (
    <div className="flex justify-center items-center h-screen">
      {agentCode ? (
        <div className="flex flex-col items-start w-1/3">
          <label className="text-gray-500 my-2" htmlFor="agentCode">
            Agent Code
          </label>
          <input
            type="text"
            value={agentCode}
            disabled
            className="text-center w-full text-xl p-3 border border-gray-300 rounded"
          />
        </div>
      ) : (
        <form onSubmit={handleSubmit} className="flex flex-col w-full md:w-1/3 mx-4 md:mx-0 items-start">
          <label className="text-gray-500 my-2" htmlFor="agentCode">
            Agent Code
          </label>
          <input
            type="text"
            placeholder="Enter agent code"
            value={inputCode}
            onChange={(e) => setInputCode(e.target.value)}
            required
            className="mb-4 p-3 w-full border border-gray-300 rounded"
          />
          <button
            type="submit"
            disabled={isSubmitting}
            className={`px-6 py-2 w-full bg-green-500 text-white rounded transition-colors ${isSubmitting ? 'opacity-50 cursor-not-allowed' : 'hover:bg-green-600'
              }`}
          >
            {isSubmitting ? 'Submitting...' : 'Submit'}
          </button>
          {error && <p className="text-red-500 mt-4">{error}</p>}
        </form>
      )}
    </div>
  );
}

export default AgentCode;